import { ajaxService } from '../../common/Services';
import { ApiUtils } from '../../common/api';
import Collection from './';

const fetchCollection = (collectionId) =>
  ajaxService
    .get(`/api/collection/show/${collectionId}.json`)
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(Collection.Model.deserialize);

/**
 * The defaultCollection endpoint used here returns the socialExperience/inNetworkExperience
 * collection as the default collection for an experience.
 */
const fetchCollectionByExperience = (experienceId) =>
  ajaxService
    .get('/api/collection/defaultCollection.json', { campaignObjectId: experienceId })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(Collection.Model.deserialize);

const fetchCollections = (search, offset = 0, max = 20) =>
  ajaxService
    .get('/api/collection/list.json', {
      collectionName: search,
      max,
      offset,
      isPublic:       true,
      sort:           'lastUpdated',
      order:          'desc',
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extractWithMeta(['count']))
    .then(Collection.Collection.deserialize);

/**
 * The defaultCollection endpoint used here returns the socialExperience/inNetworkExperience
 * collection as the default collection for an experience.
 */
const fetchDefaultCollection = (campaignObjectId) =>
  ajaxService
    .get('/api/collection/defaultCollection.json', { campaignObjectId })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(Collection.Model.deserialize);

const createCollection = (collection) =>
  ajaxService
    .post('/api/collection/save.json', Collection.Model.serialize(collection), null, { postJSON: true })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(Collection.Model.deserialize);

const updateCollection = (collection) => {
  return ajaxService
    .post(`/api/collection/update/${collection.id}.json`, Collection.Model.serialize(collection), null, {
      postJSON: true,
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(Collection.Model.deserialize);
};

const deleteCollection = (collectionId) =>
  ajaxService.post(`/api/collection/delete/${collectionId}.json`).then(ApiUtils.validate, ApiUtils.validate);

const clearCollectionContent = (collectionId, keepSeeded) =>
  ajaxService
    .post('/api/collection/content/purgeAllBefore.json', {
      collection: collectionId,
      keepSeeded,
    })
    .then(ApiUtils.validate, ApiUtils.validate);

export default {
  fetchCollection,
  fetchCollections,
  fetchCollectionByExperience,
  fetchDefaultCollection,
  createCollection,
  updateCollection,
  deleteCollection,
  clearCollectionContent,
};
